/* Reway Search Core v2
   Gedeelde, pure query-parser en relevantielaag voor predictive search en /search.
   ES5/UMD: dezelfde code draait in Shopify en in de Node-regressietests. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.RewaySearch = api;
}(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : this), function () {
  'use strict';

  var ALIASES = {
    ps1: 'playstation 1', psx: 'playstation 1', psone: 'playstation 1',
    ps2: 'playstation 2', ps3: 'playstation 3', ps4: 'playstation 4', ps5: 'playstation 5',
    playstation1: 'playstation 1', playstation2: 'playstation 2', playstation3: 'playstation 3',
    playstation4: 'playstation 4', playstation5: 'playstation 5',
    psvita: 'ps vita', vita: 'ps vita',
    xbox360: 'xbox 360', x360: 'xbox 360',
    xboxone: 'xbox one', xbone: 'xbox one', xb1: 'xbox one', xbox1: 'xbox one',
    xboxseriesx: 'xbox series x', xsx: 'xbox series x',
    wiiu: 'wii u', nintendoswitch2: 'nintendo switch 2', nintendoswitch: 'nintendo switch',
    gameboy: 'game boy', gba: 'game boy advance', gbc: 'game boy color',
    n64: 'nintendo 64', ngc: 'gamecube', gcn: 'gamecube', nds: 'ds',
    mk8: 'mario kart 8', gta: 'grand theft auto',
    spelcomputer: 'console', fototoestel: 'camera', gamepad: 'controller',
    ebookreader: 'e-reader', ereader: 'e-reader', 'e reader': 'e-reader',
    spiegelreflex: 'dslr camera', spiegelreflexcamera: 'dslr camera'
  };

  var TOKEN_EQUIV = {
    console: ['console', 'consoles'], consoles: ['console', 'consoles'],
    camera: ['camera', 'cameras', 'compactcamera', 'systeemcamera', 'spiegelreflexcamera', 'bridgecamera', 'actioncam', 'filmcamera', 'wegwerpcamera'],
    cameras: ['camera', 'cameras', 'compactcamera', 'systeemcamera', 'spiegelreflexcamera', 'bridgecamera', 'actioncam', 'filmcamera', 'wegwerpcamera'],
    controller: ['controller', 'controllers', 'gamepad'], controllers: ['controller', 'controllers', 'gamepad'],
    laptop: ['laptop', 'laptops'], laptops: ['laptop', 'laptops'],
    printer: ['printer', 'printers'], printers: ['printer', 'printers'],
    ereader: ['ereader', 'e-reader'],
    dslr: ['dslr', 'spiegelreflexcamera']
  };

  var MAIN_TYPES = makeSet(('games|consoles|handheld consoles|compactcamera|instant camera|filmcamera|systeemcamera|analoge camera|camera|spiegelreflexcamera|bridgecamera|actioncam|360-graden camera|wegwerpcamera|lenzen|sets|bouwsets|minifiguren|e-reader|smartphones|tablets|laptops|monitoren|mediaspeler|projector|printer|printers & scanners|speakers|headset|koptelefoon|gaming headset|airpods|smartwatch|horloges|navigatie|airwrap|fohn|stijltang|babyfoons|bordspellen|kaartspellen|puzzels|mp3-spelers|radio|cd-speler|draagbare dvd-spelers|vr headset|verrekijkers|telescopen|dash cam|labelprinters|grafische rekenmachine|rekenmachines|webcams').split('|'));
  /* Houd dit gelijk met de brede RW_T_ACC-taxonomie in search-fix.js. Een
     expliciet producttype is betrouwbaarder dan alleen woorden uit de titel. */
  var ACCESSORY_TYPES = makeSet((
    'acculaders|camera-accus|cameratas|controller|filters|cases & tassen|opzetstukken|stofzuigeraccessoires|stofzuigerfilters|haarstyling accessoires|' +
    'lensdop|camera-accessoires|zonnekap|kabels & adapters|afstandsbedieningen|opladers & docks|geheugenkaarten|geheugenkaarten & opslag|stroomadapter|' +
    'skins & covers|overige kabels|console accessoire|camera afstandsbediening|laptopopladers|kabels|camerakabels|game cases & hoesjes|batterijgrip|' +
    'batterij grip|schoudertassen|accu|camerariem|e-reader hoesje|case|opladers|accessoires|accu\'s & batterijen|flitseraccessoires|houders|riemen|' +
    'onderdelen & reparatie|screenprotectors|adapters|stroomkabel|kaartlezer|adapterringen|overige accessoires|standaards & houders|polsbandjes & straps|' +
    'grips & handvatten|camera harnas|stroomadapters & voedingen|batterijklepje|dockingstations|beeldschermadapters|cameragreep|losse onderdelen|usb-adapters|' +
    'statiefkoppen|kaartspel accessoires|draadloze opladers|telefoonhoesjes|oplaadcase|camera behuizing|geheugenkaart-adapters|consolestandaards|styluspennen|' +
    'stylus|lensadapters|accessoirepakketten|netwerkadapters|horlogebandjes|geheugenkaarthouder|bodydoppen|laptopstandaards|tablet hoezen|usb-hubs|' +
    'displaystandaards|flits adapter|batterijen|printeraccessoires|beveiligingscamera accessoires|sensor bar|laptop hoezen|tablet accessoires|oortips|dock|' +
    'gps-hoes|telefoonaccus|oplaadstandaard|oplaadstation|bluetooth-adapter|kaarthoezen|scanner accessoire|rekenmachine accessoires|monitor standaarden|' +
    'voedingskabels|vr headset onderdelen|lenstas|tv accessoires|tv-accessoire|beamertassen|dozen & handleidingen|webcam cover|oplaadkabel|batterijhouder|' +
    'game accessoires|netwerkkabels|audio-accessoires|verrekijker accessoires|mp3-speler accessoires|zoekerkap|drone-accessoires|spotting scope accessoires|' +
    'rekenmachine onderdelen|autoladers|wandhouder|speakertas|tv-beugels|verlichtingsaccessoires|handleiding|camerafilters|dronekoffer|' +
    'activiteitsmeter-accessoires|fietsstuuraccessoires|padelaccessoires|surfaccessoires|reisadapters|muismatten|polssteunen|telefoonstandaards'
  ).split('|'));
  var ACCESSORY_WORDS = makeSet(('hoesje hoes hoesjes case cover adapter adapters oplader charger kabel cable controller stand houder holder mount tas bag cameratas screenprotector protector dock station grip joystick afstandsbediening afstandsbedieningen remote strap bandje oplaadstation laadstation batterijgrip filter filters accu accus batterij lader acculader lensdop zonnekap riem skin sleepcover oortips onderdeel onderdelen accessoire accessoires stroomkabel voeding gamepad').split(' '));
  var PRICE_WORDS = makeSet(('onder tot maximaal max boven vanaf minimaal tussen euro eur').split(' '));

  function makeSet(list) {
    var out = {};
    for (var i = 0; i < list.length; i++) if (list[i]) out[fold(list[i])] = true;
    return out;
  }

  function fold(value) {
    var s = String(value == null ? '' : value).toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/ß/g, 'ss').replace(/æ/g, 'ae').replace(/œ/g, 'oe')
      .replace(/[’']/g, '').replace(/\s+/g, ' ').trim();
  }

  function words(value) {
    return fold(value).match(/[a-z0-9]+/g) || [];
  }

  function compact(value) {
    return fold(value).replace(/[^a-z0-9]+/g, '');
  }

  function unique(list) {
    var seen = {}, out = [];
    for (var i = 0; i < list.length; i++) {
      var key = String(list[i]);
      if (!key || seen[key]) continue;
      seen[key] = true; out.push(list[i]);
    }
    return out;
  }

  function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function expandAliases(query) {
    var out = String(query == null ? '' : query).replace(/"/g, ' ').trim();
    var keys = Object.keys(ALIASES).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var pattern = escRe(key).replace(/\\ /g, '\\s+').replace(/\\-/g, '[-\\s]?');
      out = out.replace(new RegExp('(^|[^a-z0-9])' + pattern + '(?=$|[^a-z0-9])', 'ig'), function (_, lead) {
        return lead + ALIASES[key];
      });
    }
    return out.replace(/\s+/g, ' ').trim();
  }

  function numberValue(s) { return parseFloat(String(s).replace(',', '.')); }

  function extractPrice(query) {
    var source = String(query || '');
    var price = null;
    var between = /\b(?:tussen)\s*(?:€\s*)?(\d+(?:[.,]\d+)?)\s*(?:euro|eur)?\s*(?:en|tot|-)\s*(?:€\s*)?(\d+(?:[.,]\d+)?)\s*(?:euro|eur)?\b/i;
    var max = /\b(?:onder|tot|maximaal|max)\s*(?:€\s*)?(\d+(?:[.,]\d+)?)\s*(?:euro|eur)?\b/i;
    var min = /\b(?:boven|vanaf|minimaal)\s*(?:€\s*)?(\d+(?:[.,]\d+)?)\s*(?:euro|eur)?\b/i;
    var m = between.exec(source);
    if (m) {
      price = { min: Math.min(numberValue(m[1]), numberValue(m[2])), max: Math.max(numberValue(m[1]), numberValue(m[2])) };
      source = source.replace(m[0], ' ');
    } else if ((m = max.exec(source))) {
      price = { min: null, max: numberValue(m[1]) };
      source = source.replace(m[0], ' ');
    } else if ((m = min.exec(source))) {
      price = { min: numberValue(m[1]), max: null };
      source = source.replace(m[0], ' ');
    }
    return { query: source.replace(/\s+/g, ' ').trim(), price: price };
  }

  function entity(key, compactForms, looseTokens, forbidPattern, requirePattern) {
    return {
      key: key,
      compactForms: compactForms || [],
      looseTokens: looseTokens || [],
      forbidPattern: forbidPattern || null,
      requirePattern: requirePattern || null
    };
  }

  function detectEntities(expanded) {
    var n = fold(expanded), c = compact(expanded), out = [];
    var m = /\bplaystation\s*([1-5])\b/.exec(n);
    if (m) out.push(entity('playstation-' + m[1], ['playstation' + m[1], 'ps' + m[1]]));
    /* "switch" is also a normal networking/AV product. Only infer Nintendo
       without the brand when the surrounding query is not hardware-related. */
    var hardwareSwitch = /\b(?:network|netwerk|ethernet|hdmi|kvm|poe|lan|gigabit|matrix|selector|splitter|poort|poorten|port|ports)\b/.test(n);
    var explicitSwitch2 = /\bnintendo\s+switch\s*2\b/.test(n);
    var switch2 = /\bswitch\s*2\b/.test(n);
    if (explicitSwitch2 || (!hardwareSwitch && switch2)) {
      out.push(entity('nintendo-switch-2', ['nintendoswitch2'], ['nintendo', 'switch', '2'], null, /\bswitch\s*2\b/));
    } else if (/\bnintendo\s+switch\b/.test(n) || (!hardwareSwitch && /\bswitch\b/.test(n))) {
      out.push(entity('nintendo-switch', ['nintendoswitch'], ['nintendo', 'switch'], /\bswitch\s*2\b/));
    }
    if (/\bxbox\s*360\b/.test(n)) out.push(entity('xbox-360', ['xbox360']));
    if (/\bxbox\s+one\b/.test(n)) out.push(entity('xbox-one', ['xboxone']));
    if (/\bxbox\s+series\s+x\b/.test(n)) out.push(entity('xbox-series-x', ['xboxseriesx']));
    if (/\bxbox\s+series\s+s\b/.test(n)) out.push(entity('xbox-series-s', ['xboxseriess']));
    if (/\bwii\s+u\b/.test(n)) out.push(entity('wii-u', ['wiiu']));
    else if (/\bwii\b/.test(n)) out.push(entity('wii', ['wii'], [], /\bwii\s+u\b/));
    if (/\b(?:nintendo\s+)?3ds\b/.test(n)) out.push(entity('nintendo-3ds', ['nintendo3ds', '3ds']));
    if (/\bgame\s+boy\s+advance\b/.test(n)) out.push(entity('game-boy-advance', ['gameboyadvance', 'gba']));
    else if (/\bgame\s+boy\s+color\b/.test(n)) out.push(entity('game-boy-color', ['gameboycolor', 'gbc']));
    else if (/\bgame\s+boy\b/.test(n)) out.push(entity('game-boy', ['gameboy']));
    if (/\bps\s+vita\b/.test(n) || c === 'psvita') out.push(entity('ps-vita', ['psvita', 'playstationvita']));
    return out;
  }

  function entityConsumedWords(entities) {
    var out = {};
    for (var i = 0; i < entities.length; i++) {
      var ws = words(entities[i].key.replace(/-/g, ' '));
      for (var j = 0; j < ws.length; j++) out[ws[j]] = true;
      if (entities[i].key.indexOf('playstation-') === 0) { out.playstation = true; out.ps = true; out[entities[i].key.slice(-1)] = true; }
      if (entities[i].key === 'nintendo-switch' || entities[i].key === 'nintendo-switch-2') { out.nintendo = true; out.switch = true; }
      if (entities[i].key === 'nintendo-switch-2') out['2'] = true;
    }
    return out;
  }

  function parseQuery(query) {
    var raw = String(query == null ? '' : query).replace(/\s+/g, ' ').trim();
    var priced = extractPrice(raw);
    var expanded = expandAliases(priced.query);
    var normalized = fold(expanded);
    var allWords = words(expanded);
    var rawCompact = compact(priced.query);
    var eans = [], skus = [];
    if (/^\d{8,14}$/.test(rawCompact) && /^\s*\d[\d\s-]*\s*$/.test(priced.query)) eans.push(rawCompact);
    if (!eans.length && /^[a-z0-9][a-z0-9.\/_-]{5,}$/i.test(priced.query) && /[a-z]/i.test(priced.query) && /\d/.test(priced.query) && /[.\/_-]/.test(priced.query)) skus.push(rawCompact);
    var entities = detectEntities(expanded);
    var consumed = entityConsumedWords(entities);
    var hardModels = [];
    var modelRe = /\b(?:[a-z]+\d+[a-z0-9]*|\d+[a-z]+[a-z0-9]*)\b/ig, mm;
    while ((mm = modelRe.exec(normalized))) hardModels.push(compact(mm[0]));
    var aperture = /\bf\s*[\/-]?\s*(\d+(?:[.,]\d+)?)\b/i.exec(priced.query);
    if (aperture) hardModels.push('f' + compact(aperture[1]));
    for (var i = 0; i < allWords.length; i++) {
      var w = allWords[i];
      if (/^\d+$/.test(w) && !consumed[w] && !eans.length && !skus.length) hardModels.push(w);
    }
    hardModels = unique(hardModels);
    if (eans.length || skus.length) hardModels = [];
    var hardSet = makeSet(hardModels);
    var terms = [];
    for (i = 0; i < allWords.length; i++) {
      w = allWords[i];
      if (eans.length || skus.length) continue;
      if (PRICE_WORDS[w] || consumed[w] || hardSet[compact(w)]) continue;
      if (w.length === 1 && w !== 'x' && w !== 's') continue;
      terms.push(w);
    }
    terms = unique(terms);
    var accessoryIntent = false;
    for (i = 0; i < allWords.length; i++) if (ACCESSORY_WORDS[allWords[i]]) accessoryIntent = true;
    return {
      raw: raw,
      normalized: normalized,
      expanded: expanded,
      apiQuery: (eans.length || skus.length) ? priced.query : expanded,
      tokens: allWords,
      terms: terms,
      price: priced.price,
      eans: eans,
      skus: skus,
      entities: entities,
      hardModels: hardModels,
      accessoryIntent: accessoryIntent
    };
  }

  function attr(node, names) {
    if (!node || !node.getAttribute) return '';
    for (var i = 0; i < names.length; i++) {
      var value = node.getAttribute(names[i]);
      if (value != null && value !== '') return value;
    }
    var card = node.querySelector && node.querySelector('.rw-pcard, .rw-pcard2');
    if (card && card !== node) return attr(card, names);
    return '';
  }

  function textFrom(node, selectors) {
    if (!node || !node.querySelector) return '';
    for (var i = 0; i < selectors.length; i++) {
      var el = node.querySelector(selectors[i]);
      if (el && el.textContent) return el.textContent;
    }
    return '';
  }

  function list(value) {
    if (value == null) return [];
    if (Object.prototype.toString.call(value) === '[object Array]') return value;
    return String(value).split(/[|,]/).map(function (x) { return x.trim(); }).filter(Boolean);
  }

  function makeRecord(input) {
    input = input || {};
    var isNode = !!input.getAttribute;
    var title = isNode ? (attr(input, ['data-rw-title']) || textFrom(input, ['.rw-pcard__title', '.rw-pcard2__title', '.rw-ps__t'])) : (input.title || '');
    var vendor = isNode ? (attr(input, ['data-rw-vendor']) || textFrom(input, ['.rw-pcard__vendor', '.rw-pcard2__vendor'])) : (input.vendor || '');
    var type = isNode ? attr(input, ['data-rw-type']) : (input.productType || input.type || '');
    var tags = isNode ? attr(input, ['data-rw-tags']) : (input.tags || '');
    var model = isNode ? attr(input, ['data-rw-model']) : (input.model || '');
    var skus = list(isNode ? attr(input, ['data-rw-skus', 'data-rw-sku']) : (input.skus || input.sku));
    var barcodes = list(isNode ? attr(input, ['data-rw-barcodes', 'data-rw-barcode']) : (input.barcodes || input.barcode));
    var body = isNode ? '' : (input.body || input.description || '');
    var price = null;
    if (isNode) {
      var cents = attr(input, ['data-rw-amin', 'data-rw-price-cents']);
      var euros = attr(input, ['data-rw-price']);
      if (cents !== '') price = Number(cents) / 100;
      else if (euros !== '') price = Number(euros);
    } else if (input.priceCents != null) price = Number(input.priceCents) / 100;
    else if (input.price != null && input.price !== '') price = Number(input.price);
    var combined = [title, vendor, type, tags, model, body].join(' ');
    var tokenList = words(combined), tokenSet = makeSet(tokenList);
    var titleTokens = words(title), vendorTokens = words(vendor), typeTokens = words(type);
    var tagTokens = words(tags), modelTokens = words(model), bodyTokens = words(body);
    var typeKey = fold(type);
    var main = input.main != null ? !!input.main : !!MAIN_TYPES[typeKey];
    var accessory = input.accessory != null ? !!input.accessory : !!ACCESSORY_TYPES[typeKey];
    if (!accessory) for (var i = 0; i < tokenList.length; i++) if (ACCESSORY_WORDS[tokenList[i]]) { accessory = true; break; }
    return {
      node: isNode ? input : null,
      title: fold(title), vendor: fold(vendor), type: typeKey, tags: fold(tags), model: fold(model), body: fold(body),
      normalized: fold(combined), compact: compact(combined), titleCompact: compact(title), vendorCompact: compact(vendor), modelCompact: compact(model),
      tokens: tokenList, tokenSet: tokenSet,
      titleTokens: titleTokens, titleTokenSet: makeSet(titleTokens),
      vendorTokens: vendorTokens, vendorTokenSet: makeSet(vendorTokens),
      typeTokens: typeTokens, typeTokenSet: makeSet(typeTokens),
      tagTokens: tagTokens, tagTokenSet: makeSet(tagTokens),
      modelTokens: modelTokens, modelTokenSet: makeSet(modelTokens),
      bodyTokens: bodyTokens, bodyTokenSet: makeSet(bodyTokens),
      skus: skus.map(compact), barcodes: barcodes.map(compact),
      price: isNaN(price) ? null : price,
      available: input.available == null ? true : !!input.available,
      url: input.url || (isNode && input.querySelector && input.querySelector('a[href]') ? input.querySelector('a[href]').getAttribute('href') : ''),
      main: main, accessory: accessory
    };
  }

  function lev(a, b) {
    if (a === b) return 0;
    var row = [], i, j, prev, tmp;
    for (j = 0; j <= b.length; j++) row[j] = j;
    for (i = 1; i <= a.length; i++) {
      prev = row[0]; row[0] = i;
      for (j = 1; j <= b.length; j++) {
        tmp = row[j];
        row[j] = Math.min(row[j] + 1, row[j - 1] + 1, prev + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
        prev = tmp;
      }
    }
    return row[b.length];
  }

  function tokenAlternatives(term) { return TOKEN_EQUIV[term] || [term]; }

  function tokenMatchKind(term, tokenList, tokenSet) {
    tokenList = tokenList || [];
    tokenSet = tokenSet || {};
    var alternatives = tokenAlternatives(term);
    for (var a = 0; a < alternatives.length; a++) if (tokenSet[alternatives[a]]) return 2;
    if (!/^[a-z]+$/.test(term) || term.length < 5) return 0;
    var max = term.length >= 8 ? 2 : 1;
    for (var i = 0; i < tokenList.length; i++) {
      var candidate = tokenList[i];
      if (!/^[a-z]+$/.test(candidate) || candidate.charAt(0) !== term.charAt(0) || Math.abs(candidate.length - term.length) > max) continue;
      if (lev(term, candidate) <= max) return 1;
    }
    return 0;
  }

  function tokenMatches(term, rec) {
    return tokenMatchKind(term, rec.tokens, rec.tokenSet) > 0;
  }

  function tokenFieldScore(term, rec) {
    var kind = tokenMatchKind(term, rec.titleTokens, rec.titleTokenSet);
    if (kind) return kind === 2 ? 40 : 32;
    kind = tokenMatchKind(term, rec.vendorTokens, rec.vendorTokenSet);
    if (kind) return kind === 2 ? 27 : 20;
    kind = tokenMatchKind(term, rec.modelTokens, rec.modelTokenSet);
    if (kind) return kind === 2 ? 25 : 18;
    kind = tokenMatchKind(term, rec.typeTokens, rec.typeTokenSet);
    if (kind) return kind === 2 ? 18 : 13;
    kind = tokenMatchKind(term, rec.tagTokens, rec.tagTokenSet);
    if (kind) return kind === 2 ? 10 : 6;
    kind = tokenMatchKind(term, rec.bodyTokens, rec.bodyTokenSet);
    if (kind) return kind === 2 ? 6 : 4;
    return 2;
  }

  function hasBrandedModelIntent(parsed, rec) {
    if (parsed.accessoryIntent || parsed.terms.length < 2) return false;
    for (var i = 0; i < parsed.terms.length; i++) {
      if (tokenMatchKind(parsed.terms[i], rec.vendorTokens, rec.vendorTokenSet) !== 2) continue;
      for (var j = 0; j < parsed.terms.length; j++) {
        if (j === i) continue;
        if (tokenMatchKind(parsed.terms[j], rec.titleTokens, rec.titleTokenSet) === 2 ||
            tokenMatchKind(parsed.terms[j], rec.modelTokens, rec.modelTokenSet) === 2) return true;
      }
    }
    return false;
  }

  function entityPresent(ent, rec) {
    if (ent.requirePattern && !ent.requirePattern.test(rec.normalized)) return false;
    if (ent.forbidPattern && ent.forbidPattern.test(rec.normalized)) return false;
    for (var i = 0; i < ent.compactForms.length; i++) {
      var f = ent.compactForms[i];
      if (rec.titleCompact.indexOf(f) !== -1 || rec.vendorCompact.indexOf(f) !== -1 || rec.modelCompact.indexOf(f) !== -1 || rec.tokenSet[f]) return true;
    }
    if (ent.looseTokens.length) {
      for (i = 0; i < ent.looseTokens.length; i++) if (!rec.tokenSet[ent.looseTokens[i]]) return false;
      return true;
    }
    return false;
  }

  function modelPresent(model, rec) {
    if (/^\d+$/.test(model)) return !!rec.tokenSet[model];
    if (rec.tokenSet[model] || rec.modelCompact === model) return true;
    return rec.titleCompact.indexOf(model) !== -1 || rec.modelCompact.indexOf(model) !== -1;
  }

  function matches(parsed, record) {
    var rec = record && record.tokenSet ? record : makeRecord(record);
    var i;
    if (parsed.eans.length) {
      for (i = 0; i < parsed.eans.length; i++) if (rec.barcodes.indexOf(parsed.eans[i]) === -1) return false;
    }
    if (parsed.skus.length) {
      for (i = 0; i < parsed.skus.length; i++) if (rec.skus.indexOf(parsed.skus[i]) === -1) return false;
    }
    for (i = 0; i < parsed.entities.length; i++) if (!entityPresent(parsed.entities[i], rec)) return false;
    for (i = 0; i < parsed.hardModels.length; i++) if (!modelPresent(parsed.hardModels[i], rec)) return false;
    for (i = 0; i < parsed.terms.length; i++) if (!tokenMatches(parsed.terms[i], rec)) return false;
    if (parsed.price && rec.price != null) {
      if (parsed.price.min != null && rec.price < parsed.price.min) return false;
      if (parsed.price.max != null && rec.price > parsed.price.max) return false;
    }
    return !!(parsed.eans.length || parsed.skus.length || parsed.entities.length || parsed.hardModels.length || parsed.terms.length);
  }

  function isPlatformOnly(parsed) {
    return parsed.entities.length > 0 && !parsed.accessoryIntent && parsed.terms.length === 0 && parsed.hardModels.length === 0;
  }

  function score(parsed, record) {
    var rec = record && record.tokenSet ? record : makeRecord(record);
    if (!matches(parsed, rec)) return -100000;
    var s = 0, i;
    if (parsed.eans.length || parsed.skus.length) s += 10000;
    s += parsed.entities.length * 600;
    s += parsed.hardModels.length * 300;
    var phrase = fold(parsed.expanded).replace(/[^a-z0-9]+/g, ' ').trim();
    if (phrase && (' ' + rec.title.replace(/[^a-z0-9]+/g, ' ') + ' ').indexOf(' ' + phrase + ' ') !== -1) s += 200;
    for (i = 0; i < parsed.terms.length; i++) s += tokenFieldScore(parsed.terms[i], rec);
    if (isPlatformOnly(parsed)) {
      if (rec.type === 'consoles' || rec.type === 'handheld consoles') s += 520;
      else if (rec.type === 'games') s += 180;
      else if (rec.accessory) s -= 180;
      else s -= 60;
    } else if (parsed.accessoryIntent) {
      if (rec.accessory) s += 150;
      if (rec.main && !rec.accessory) s -= 40;
    } else {
      if (rec.main) s += 120;
      if (rec.accessory) s -= 90;
    }
    if (hasBrandedModelIntent(parsed, rec)) {
      if (rec.main && !rec.accessory) s += 140;
      if (rec.accessory) s -= 160;
    }
    if (/\b(?:camera|dslr|compactcamera)\b/.test(parsed.normalized)) {
      if (/camera/.test(rec.type) && rec.type !== 'cameratas' && rec.type !== 'camera-accessoires') s += 100;
      if (rec.type === 'cameratas' || rec.type === 'camera-accessoires') s -= 140;
    }
    if (/\b(?:console|consoles)\b/.test(parsed.normalized) && (rec.type === 'consoles' || rec.type === 'handheld consoles')) s += 140;
    return s - Math.min(30, rec.title.length / 20);
  }

  function evaluate(parsed, record) {
    var rec = record && record.tokenSet ? record : makeRecord(record);
    var ok = matches(parsed, rec);
    return { matches: ok, score: ok ? score(parsed, rec) : -100000, confidence: ok ? fallbackConfidence(parsed, rec) : 0, record: rec };
  }

  function rank(parsed, records) {
    return records.map(function (r, index) {
      var rec = r && r.tokenSet ? r : makeRecord(r);
      return { item: r, record: rec, index: index, score: score(parsed, rec) };
    }).filter(function (x) { return x.score > -100000; })
      .sort(function (a, b) { return b.score - a.score || a.index - b.index; });
  }

  function fallbackConfidence(parsed, record) {
    var rec = record && record.tokenSet ? record : makeRecord(record);
    if (!matches(parsed, rec)) return 0;
    if (parsed.eans.length || parsed.skus.length) return 1;
    var total = parsed.terms.length + parsed.entities.length + parsed.hardModels.length;
    if (!total) return 0;
    var exact = parsed.entities.length + parsed.hardModels.length;
    for (var i = 0; i < parsed.terms.length; i++) if (rec.tokenSet[parsed.terms[i]]) exact++;
    return Math.min(1, 0.72 + (exact / total) * 0.28);
  }

  function isConfidentFallback(parsed, record) { return fallbackConfidence(parsed, record) >= 0.72; }

  return {
    aliases: ALIASES,
    fold: fold,
    words: words,
    compact: compact,
    expand: expandAliases,
    expandAliases: expandAliases,
    parse: parseQuery,
    parseQuery: parseQuery,
    record: makeRecord,
    makeRecord: makeRecord,
    matches: matches,
    evaluate: evaluate,
    score: score,
    rank: rank,
    fallbackConfidence: fallbackConfidence,
    isConfidentFallback: isConfidentFallback
  };
}));
